class Process {
    constructor(name, dataType) {
        this.name = name
        this.dataType = dataType
        this.activeIndex = 0
    }
}

export default Process